// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_fo-0";
export var headerCellHover = "_fo-1";
export var readCellContainer = "_fo-2";
export var unreadIndicator = "_fo-3";